<div class="payment-result__state payment-result__state--generic">
  @switch (status()) {
    @case ('USER_CONFIRMATION_REQUIRED') {
      <p>Este comprobante necesita confirmación de datos, pero aún no está disponible por este canal.</p>
    }
    @case ('CHANNEL_NOT_ALLOWED') {
      <p>
        ⚠️ No pudimos registrar tu comprobante porque los pagos realizados por
        Agente, Ventanilla o Cajero no están habilitados para tu empresa.
        Por favor, realiza tu pago por un canal digital del BCP y envía ese comprobante.
      </p>
    }
    @case ('ERROR_AGENT') {
      <p>Tengo algunos problemas técnicos al analizar el comprobante ahora. Por favor, vuelve a enviarme el comprobante en unos minutos.</p>
    }
    @case ('ERROR_PROCESSOR') {
      <p>Tengo algunos problemas técnicos al momento de realizar la validación. Por favor, vuelve a intentarlo en unos minutos.</p>
    }
    @default {
      <p>Resultado pendiente de revisión.</p>
    }
  }
</div>
